<template lang="pug">
.renewal-container(v-if="show")
  .close-btn(@click="close")
    img(src="https://m.hellobike.com/resource/helloyun/08345/nEFYzuxKIh.png?x-oss-process=image/quality,q_80")
  .renewal-block
    .renewal-block-list
      .business-list
        .business-list-item(v-for="(item,index) in commonBonus"
        @click="changeBusiness(item,index)")
          .business-img
            img.business-top-img(:src="item.bonusEntity.icon")
          .business-title {{item.bonusEntity.mainTitle}}
          .business-word {{item.bonusEntity.subTitle}}
          .business-sign(v-if="guid === item.guid")
            img(src="https://m.hellobike.com/resource/helloyun/08345/yeXu1I8c6s.png?x-oss-process=image/quality,q_80")
      .bussiness-block(:style="autoRenewalStatus!==RENEWAL_STATUS.available?bolckHeight:''")
        .bussiness-slogan {{chooseObj.slogan}}
        .bussiness-bonusPic
          img.bonusPic(:src="chooseObj.bonusPic")
        .bussiness-detail 权益详情
        .bussiness-bonusDetailPic
          img.bonusDetailPic(:src="chooseObj.bonusDetailPic")
        .bussiness-bottom-height
    div(v-if="type===1")
      VipButtonNew(
        v-if="showStyleVersion!=='ladderEasy'"
        :info='info' @open="bayCardHandler" @openDialog="openDialog"
        @transTab="getTransTab"
        :time="price.couponEndTime||0"
        :unOpenShowCanBuy="unOpenShowCanBuy"
        :readSign="isRead"
        @isNoReadSign="openRead")
      vipButtonLadder(
        v-else,
        ref="buttonNew",
        :info="info",
        :readSign="isRead"
        @open="bayCardHandler",
        @openDialog="openDialog",
        @transTab="getTransTab",
        @isNoReadSign="openRead"
        :unOpenShowCanBuy="unOpenShowCanBuy"
      )
    div.close-bottom(v-else)
      .close-bottom-btn(@click="goBtnLine(chooseObj)") {{chooseObj.buttonLabel}}
    readModal.read-modules(
      :show="showRead"
      @close="showRead=false"
      @readOk="readOk"
    )
  .shadow(@click="close")

</template>
<script>
import Lottie from '@/components/lottie';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { Native, env } from '@hb/hbridge';
import { Navigator } from '@hb/h5-navigator';
import { RENEWAL_STATUS } from '../../consts';
import { getSource } from '../../../../utils';
import TransTab from './transTab.vue';
import VipButtonNew from './vip-button-new.vue';
import readModal from './read-modal';
import vipButtonLadder from './vip-button-ladder.vue';


export default {
  components: {
    Lottie,
    TransTab,
    VipButtonNew,
    readModal,
    vipButtonLadder,
  },
  props: {
    autoRenewalStatus: {
      type: String,
      default: '',
    },
    type: {
      type: Number,
      default: 1,
    },
    commonBonus: {
      type: Array,
      default: () => [],
    },
    info: {
      type: Object,
      default: null,
    },
    unOpenShowCanBuy: {
      type: Boolean,
      default: true,
    },
    showStyleVersion: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      show: false,
      loadingPay: false,
      env,
      d: undefined,
      h: '',
      m: '',
      s: '',
      timer: null,
      timeout: null,
      simpleGroupInfos: [],
      markedPrice: 0,
      price: {},
      signInfoDTO: {},
      allMonth: true,
      couponEndTime: null,
      goodsGuid: '',
      RENEWAL_STATUS,
      chooseObj: {
        slogan: '',
        bonusPic: '',
        bonusDetailPic: '',
      },
      guid: '',
      bolckHeight: 'height: 3.8rem',
      showRead: false,
      isRead: false,
    };
  },
  computed: {
    openPrice() {
      if (this.allMonth) {
        return this.signInfoDTO.firstSignPrice;
      }
      return this.price || '-';
    },
  },
  destroyed() {
    this.timer = null;
    this.timeout = null;
  },
  created() {
    UBT.moduleExpose({
      pageId: 'platform_savemoneycard_page',
      categoryId: 'platform',
      moduleId: 'platform_opencard_button',
      contentId: 'platform_opencard_button',
      exposureTimes: 1,
      businessInfo: {
        adsource: getSource(),
      },
    });
  },
  methods: {
    open(val) {
      if (!val) return;
      this.show = true;
      this.chooseObj = val.bonusEntity;
      this.guid = val.guid;
      if (this.type === 1) {
        UBT.moduleExpose({
          pageId: 'platform_savemoneycard_page',
          categoryId: 'platform',
          moduleId: 'platform_Quick_navigation',
          contentId: 'platform_Quick_navigation',
          exposureTimes: 1,
          businessInfo: {},
        });
      } else {
        UBT.moduleExpose({
          pageId: 'platform_openedcard_page',
          categoryId: 'platform',
          moduleId: 'platform_Quick_navigation2',
          contentId: 'platform_Quick_navigation2',
          exposureTimes: 1,
          businessInfo: {},
        });
      }
    },
    readOk() {
      this.isRead = true;
    },
    openRead(payChannel = '') {
      this.payChannel = payChannel;
      this.isRead = false;
      this.showRead = true;
    },
    close() {
      this.$emit('closeOnePage');
      this.$emit('update:show', false);
      this.show = false;
    },
    goBtnLine(value) {
      if (env.isAlipayBrowser || env.isAliMP) {
        if (value.payedImageAliUrl === '' || !value.payedImageAliUrl) {
          this.close();
        } else {
          Native.callNative({
            method: 'goOperationUrlV2',
            params: value.payedImageAliUrl,
          }).catch();
        }
      } else if (value.payedImageUrl === '' || !value.payedImageUrl) {
        this.close();
      } else {
        Navigator.go(value.payedImageUrl);
      }
    },
    changeBusiness(item, index) {
      if (this.type === 1) {
        UBT.clickButton({
          pageId: 'platform_savemoneycard_page',
          buttonName: 'platform_Quick_navigation',
          categoryId: 'platform',
          businessInfo: {
            iconnumber: index,
          },
        });
      } else {
        UBT.clickButton({
          pageId: 'platform_openedcard_page',
          buttonName: 'platform_Quick_navigation2',
          categoryId: 'platform',
          businessInfo: {
            iconnumber: index,
          },
        });
      }

      this.chooseObj = item.bonusEntity;
      this.guid = item.guid;
    },
    handleButton() {
      this.$nextTick(() => {
        let btn = null;
        if (this.autoRenewalStatus === RENEWAL_STATUS.unavailable) {
          btn = this.$refs.button;
        } else {
          btn = this.$refs.buttonNew;
        }
        if (btn) {
          // btn.locate();
          // this.$nextTick(() => {
          //   const { classes } = btn;
          //   if (classes && classes.fixed) {
          //     this.groupsClass.radius = true;
          //   }
          // });
        }
      });
    },
    openDialog() {
      this.$emit('openDialog');
    },
    bayCardHandler(val, num, money, payChannel = '') {
      this.$emit('open', val, num, money, payChannel);
    },
    getTransTab(type, price) {
      this.transType = type;
      if (price && price !== '-') {
        this.transPrice = price;
      }
    },
    // 连续包月规则链接
    goRenewal() {
      Navigator.go('https://m.hellobike.com/mf/spa/u_hywaxn/latest/MA2209193493443248207695231.html?activityCode=MA2209193493443248207695231', { isRuleLink: true });
    },
    // 付费会员规则链接
    goMember() {
      Navigator.go('https://m.hellobike.com/mf/spa/u_yewmjx/latest/MA2209283520078470713971794.html?activityCode=MA2209283520078470713971794', { isRuleLink: true });
    },
    chooseMember(type) {
      this.allMonth = type;
    },
    openTime() {
      const now = new Date().getTime();
      // time改为couponEndTime
      this.timeout = this.couponEndTime - now;
      this.timer = setInterval(() => {
        if (this.timeout <= 0) {
          clearInterval(this.timer);
          return;
        }
        this.showTime(this.timeout);
        this.timeout -= 1000;
      }, 1000);
    },
    showTime(timeout) {
      // 后台给我的是10位 精确到秒的  所有下面我就除以了1000，不要小数点后面的
      // eslint-disable-next-line no-console
      if (timeout && timeout > 0) {
        const t = timeout;
        // eslint-disable-next-line no-console
        // 如果后台给的是毫秒 上面不用除以1000  下面的计算时间也都要除以1000 这里我去掉1000了
        this.d = Math.floor(t / 1000 / 60 / 60 / 24); // 天 var d=Math.floor(t/1000/60/60/24)
        // eslint-disable-next-line no-mixed-operators
        const h = Math.floor((t / 1000 / 60 / 60) % 24);
        // 时 var h=Math.floor(t/1000/60/60%24)
        // eslint-disable-next-line no-mixed-operators
        const m = Math.floor((t / 1000 / 60) % 60); // 分 var m=Math.floor(t/1000/60%60)
        // eslint-disable-next-line no-mixed-operators
        const s = Math.floor((t / 1000) % 60); // 秒 var s=Math.floor(t/1000%60)
        // if (parseInt(d, 10) < 10) {
        //   this.d = `0${d}`;
        // } else {
        //   this.d = `${d}`;
        // }
        if (parseInt(h, 10) < 10) {
          this.h = `0${h}`;
        } else {
          this.h = `${h}`;
        }
        if (parseInt(m, 10) < 10) {
          this.m = `0${m}`;
        } else {
          this.m = `${m}`;
        }
        if (parseInt(s, 10) < 10) {
          this.s = `0${s}`;
        } else {
          this.s = `${s}`;
        }
      }
    },
    // open() {
    //   UBT.clickButton({
    //     pageId: 'platform_savemoneycard_page',
    //     buttonName: 'platform_opencard_button',
    //     categoryId: 'platform',
    //     businessInfo: {
    //       adsource: getSource(),
    //     },
    //   });
    //   // eslint-disable-next-line no-console
    //   // console.log('val.showPopUpWindowType', val.showPopUpWindowType);
    //   // if (showPopUpWindowType !== 1) {
    //   //   this.$emit('open', null, this.allMonth ? 30 : 10, this.openPrice);
    //   // } else {
    //   //   this.$emit('openDialog');
    //   // }
    //   this.$emit('open', null, this.allMonth ? 30 : 20, this.openPrice, this.goodsGuid);
    // },
  },
};
</script>
<style lang="less" scoped>
.renewal-container {
  font-family: PingFangSC-Medium, PingFang SC, sans-serif;
  overflow: auto;

  .close-btn {
    position: fixed;
    right: 0.1rem;
    bottom: 5.9rem;
    z-index: 222;
    opacity: 0.57;

    img {
      width: 0.26rem;
      height: 0.26rem;
    }
  }

  .renewal-block {
    position: fixed;
    padding-top: 0.17rem;
    bottom: 0;
    z-index: 222;
    height: 5.8rem;
    width: 100%;
    background-image: url(https://m.hellobike.com/resource/helloyun/08345/R22hNTNZOz.png?x-oss-process=image/quality,q_80);
    background-size: cover;
    background-repeat: no-repeat;

    .renewal-block-list {
      .business-list {
        padding-left: 0.1rem;
        height: 1rem;
        width: 100%;
        display: flex;
        overflow-x: scroll;
        overflow-y: hidden;

        &::-webkit-scrollbar {
          display: none;
          width: 0;
          height: 0;
          color: transparent;
        }

        .business-list-item {
          width: 0.68rem;
          flex: 1;
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;

          .business-sign {
            position: absolute;
            bottom: 0.02rem;
            margin-top: -0.025rem;
            z-index: 2;
            width: 0.34rem;
            height: 0.23rem;

            img {
              width: 0.34rem;
              height: 0.23rem;
            }
          }

          .business-img {
            display: flex;
            width: 0.68rem;
            margin: 0 auto;

            img.business-top-img {
              margin: 0 auto;
              width: 0.46rem;
              height: 0.46rem;
            }
          }

          .business-title {
            text-align: center;
            margin-top: -0.02rem;
            font-size: 0.12rem;
            font-family: PingFangSC-Semibold, PingFang SC, sans-serif;
            font-weight: 600;
            color: #6f2500;
            opacity: 0.8;
          }

          .business-word {
            text-align: center;
            transform: scale(0.833);
            font-size: 0.12rem;
            font-family: PingFangSC-Regular, PingFang SC, sans-serif;
            font-weight: 400;
            color: rgba(165, 71, 0, 0.65);
            margin-top: -0.01rem;
          }
        }
      }

      .bussiness-block {
        height: 3.6rem;
        overflow-y: auto;
        padding: 0.08rem 0.16rem 0 0.16rem;

        .bussiness-slogan {
          font-size: 0.18rem;
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-weight: 500;
          color: #6f2500;
          height: 0.25rem;
          line-height: 0.25rem;
        }

        .bussiness-bonusPic {
          margin-top: 0.12rem;

          img.bonusPic {
            width: 100%;
          }
        }

        .bussiness-detail {
          margin-top: 0.16rem;
          font-size: 0.16rem;
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-weight: 500;
          color: #6f2500;
          line-height: 0.22rem;
        }

        .bussiness-bonusDetailPic {
          margin-top: 0.11rem;

          img.bonusDetailPic {
            width: 100%;
          }
        }

        .bussiness-bottom-height {
          height: 1.5rem;
          width: 100%;
        }
      }
    }

    .close-bottom {
      padding: 0 0.2rem;
    }

    .close-bottom-btn {
      position: fixed;
      bottom: 0.3rem;
      z-index: 10;
      left: 0.2rem;
      right: 0.2rem;
      height: 0.52rem;
      width: 3.35rem;
      background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
      box-shadow: 0 1px 8px 0 rgba(250, 87, 13, 0.4);
      border-radius: 12px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 500;
      color: #fff;
      text-align: center;
      line-height: 0.52rem;
    }
  }

  .shadow {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #000;
    opacity: 0.7;
    z-index: 220;
  }
}

.free-rights-version {
  .renewal-container {
    .renewal-block {
      background-image: url(https://assets.51downapp.cn/file-1754979552538-751761511.png);

      .renewal-block-list {
        .business-list {
          .business-list-item {
            .business-title {
              margin-top: 0;
              color: #000;
            }

            .business-word {
              color: #000;
            }
          }
        }

        .bussiness-block {
          .bussiness-slogan,
          .bussiness-detail {
            color: #7f2c00;
            font-family: "PingFang SC", sans-serif;
            font-size: 0.16rem;
            font-weight: 600;
            height: 0.25rem;
          }
        }
      }
    }
  }
}
</style>
